//Excel document text format styles
export const textCenter = `text-align: center;`;
export const textLeft = `text-align: left;`;
export const textRight = `text-align: right;`;
export const textBold = `font-weight: bold;`;
export const textMain = `
	color: black;
	font-family: Arial;
	font-size: 15px;
	vertical-align: middle;
`;
export const textSectionHeader = `
	color:black;
	font-family:Arial;
	font-size:19px;
	vertical-align:middle;
`;
export const textSection = `
	color: black;
	font-family: Arial;
	font-size: 16px;
	vertical-align: middle;
`;
export const textSoft = `
	color:gray;
	font-family:Arial;
	font-size:13px;
	vertical-align:middle;
`;
export const textDisclosure = `
	color:gray;
	font-family:Arial;
	font-size:11pt;
	vertical-align:middle;
`;
export const textTitle = `
	background-color:#4682b4;
	color:#fff;
	font-family:Arial;
	font-size:19px;
	height: 33px;
	vertical-align:middle;
`;
//Excel Document Row Heights
export const navReturnsHeaderRowHeight = `height: 95px;`;
// Excel can re-format numbers with additional, unwanted decimals (i.e., 100.00%)
// // format as 100%
// percentNoDecimal: `
// 	mso-number-format:'0%';`,
// format as 100.0%
export const percentSingleDecimal = `mso-number-format:'0.0%';`;
